import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import JobInputTitle from './JobInputTitle';
import TextField from 'material-ui/TextField';

const jobNumberInputStyles = {
    container: {margin: '0 0 1em 0'}
}

class JobNumberInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorText: null,
            value: this.props.defaultValue
        };
    }

    handleChange = (e) => {
        let value = (e.target.value) ? parseFloat(e.target.value) : null;
        let errorText = null;
        const max = this.props.max;
        const min = this.props.min;
        if (max !== undefined && value > max) {
            errorText = 'Value must be less than ' + max;
        }
        if (min !== undefined && value < min) {
            errorText = 'Value must be more than ' + min;
        }
        if (this.props.required && !value) {
            errorText = 'Required';
        }

        this.setState({
            errorText: (errorText) ? errorText : null,
            value: value
        }, () => {
            if (typeof this.props.onChange === 'function') {
                this.props.onChange(this.props.customType, this.props.name, value);
            }
        });
    };

    render() {
        const {
            customType,
            defaultValue,
            disabled,
            isFloat,
            label,
            max,
            min,
            name,
            param,
            required,
            style,
            tooltip
        } = this.props;

        const {
            errorText
        } = this.state;

        return (
            <div style={jobNumberInputStyles.container}>
                <JobInputTitle label={label} tooltip={tooltip}/>

                <Field
                    key={`job-report-param-${customType}-${param}`}
                    label={label}
                    floatingLabelText={label}
                    name={name}
                    component={TextField}
                    type="number"
                    step={(isFloat) ? 0.1 : 1}
                    defaultValue={defaultValue}
                    props={{
                        max: (max) ? max : undefined,
                        min: (min) ? min : undefined,
                        onChange: this.handleChange
                    }}
                    required={(required) ? required : undefined}
                    disabled={(disabled) ? true : undefined}
                    errorText={errorText}
                    style={style}
                />
            </div>
        )
    }
}

JobNumberInput.propTypes = {
    customType: PropTypes.string,
    defaultValue: PropTypes.number,
    disabled: PropTypes.bool,
    isFloat: PropTypes.bool,
    label: PropTypes.string,
    max: PropTypes.number,
    min: PropTypes.number,
    name: PropTypes.string,
    nativeType: PropTypes.string,
    onChange: PropTypes.func,
    param: PropTypes.string,
    required: PropTypes.bool,
    style: PropTypes.object,
    tooltip: PropTypes.string,
    value: PropTypes.number
};

JobNumberInput.defaultProps = {
    disabled: false,
    isFloat: false,
    name: 'multiplier',
    param: 'multiplier',
    nativeType: 'float',
    required: false,
    style: {}
};

export default JobNumberInput;



// WEBPACK FOOTER //
// ./src/Fuse/components/JobNumberInput.js